import type { FormInstance } from "antd";

/**
 * Обработчик кнопки «ОК» в модалке с формой.
 *
 * `form.validateFields()` при непройденной валидации возвращает ОТКЛОНЁННЫЙ
 * промис. Ошибки полей antd показывает сам, но необработанное отклонение
 * всплывает как unhandled rejection — в браузере это красная строка в консоли
 * на каждую опечатку оператора, а в тестах падение всего прогона.
 *
 * Поэтому отклонение здесь глотается осознанно: это не ошибка приложения, а
 * штатный отказ формы, уже показанный пользователю.
 */
export function onModalOk<Values>(
  form: FormInstance<Values>,
  handler: (values: Values) => Promise<void>,
): () => void {
  return () => {
    form
      .validateFields()
      .then(handler)
      .catch(() => undefined);
  };
}
